import React, { Component } from 'react';
import { isEmpty, isWaterDevice } from '../../../Common/Common';

export default class Display_Cell_Unit extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let targetInfo = this.props.target_info;

		let unit_string = 'kWh';

		//Check if Water, m³
		let pointInfo = window.app.state.point_list[targetInfo.id];

		if (!isEmpty(pointInfo)) {
			if (isWaterDevice(pointInfo)) {
				unit_string = 'm³';
			}
		}

		//Check if Water, m³
		switch (targetInfo.id) {
			case 'water_consumption_month':
			case 'water_consumption_day':
			case 'recycled_water_month':
			case 'recycled_water_day':
				unit_string = 'm³';
				break;
			default:

		}

		let font_size = (0.133) * this.props.cell_width;

		return (
			<div style={{ display: 'inline-block', verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap' }}>
				<span style={{ fontSize: font_size }}>{unit_string}</span>
			</div>
		)
	}
}